import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../../i18n';

import {
  InfoOverlayWrapper,
  InfoOverlayAnimate,
  ClosableOverlay,
} from '@wix/wix-vod-shared/components';

import ShareVideo from '../../../../components/share-info-overlay/share-video/share-video';

import localStyles from './styles.scss';

class ShareInfoOverlay extends React.Component {
  static propTypes = {
    isVisible: PropTypes.bool,
    onClose: PropTypes.func,
    siteUrl: PropTypes.string,
    channelData: PropTypes.object,
    instanceInfo: PropTypes.object,
    videoItem: PropTypes.object,
    onMoreClicked: PropTypes.func,
    isRTL: PropTypes.bool,
  };

  render() {
    const {
      isVisible,
      onClose,
      siteUrl,
      channelData,
      videoItem,
      instanceInfo,
      onMoreClicked,
      isRTL,
    } = this.props;

    return (
      <InfoOverlayWrapper className={localStyles.overlay} isActive={isVisible}>
        <InfoOverlayAnimate when={isVisible}>
          <ClosableOverlay
            dataHook="closable-overlay"
            onClose={onClose}
            posterUrl={videoItem.posterUrl}
            closeButtonAriaLabel={i18n.t('accessibility.close-share-button')}
            isFullWidth
            isRTL={isRTL}
          >
            <ShareVideo
              channelData={channelData}
              videoItem={videoItem}
              shouldShowLinkButton={false}
              siteUrl={siteUrl}
              instanceInfo={instanceInfo}
              onMoreClicked={onMoreClicked}
              isRTL={isRTL}
            />
          </ClosableOverlay>
        </InfoOverlayAnimate>
      </InfoOverlayWrapper>
    );
  }
}

export default ShareInfoOverlay;
